export default ({
  loadScriptUrl
}) => new Promise((resolve) => {
  if (window.bitcart) {
    resolve()
  }

  const script = document.createElement('script')
  script.src = loadScriptUrl

  document.body.appendChild(script)

  script.onload = () => {
      resolve()
  }
})
